var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#india_svg__clip0_6545_10389)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#india_svg__clip1_6545_10389)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6 0h36v24H-6V0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6 0h36v8H-6V0z",
    fill: "#FF6820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6 16h36v8H-6v-8z",
    fill: "#046A38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.7a3.7 3.7 0 100-7.4 3.7 3.7 0 000 7.4z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.2a3.2 3.2 0 100-6.4 3.2 3.2 0 000 6.4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.64a.64.64 0 100-1.28.64.64 0 000 1.28z",
    fill: "#07038D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.8l.12 1.926-.12.953-.12-.953L12 8.8zM12.4 8.966a.14.14 0 10.036-.278.14.14 0 00-.037.278zM12 15.2l-.12-1.926.12-.953.12.953L12 15.2zM11.6 15.034a.14.14 0 10-.036.278.14.14 0 00.037-.278zM12.828 8.91l-.382 1.89-.363.89.131-.952.614-1.829zM13.171 9.173a.14.14 0 10.107-.259.14.14 0 00-.107.259zM11.172 15.091l.382-1.891.363-.89-.131.952-.614 1.829zM10.829 14.827a.14.14 0 10-.107.259.14.14 0 00.107-.259zM13.6 9.229l-.859 1.728-.58.765.372-.886L13.6 9.23zM13.863 9.572a.14.14 0 10.17-.222.14.14 0 00-.17.222zM10.4 14.771l.859-1.727.58-.766-.372.886L10.4 14.77zM10.137 14.428a.14.14 0 10-.17.222.14.14 0 00.17-.222zM14.263 9.737l-1.277 1.447-.759.59.59-.76 1.446-1.277zM14.428 10.137a.14.14 0 10.222-.17.14.14 0 00-.223.17zM9.737 14.263l1.277-1.447.759-.589-.59.759-1.446 1.277zM9.572 13.863a.14.14 0 10-.222.17.14.14 0 00.222-.17zM14.771 10.4l-1.607 1.067-.886.373.765-.581 1.728-.859zM14.827 10.83a.14.14 0 10.259-.108.14.14 0 00-.259.107zM9.229 13.6l1.607-1.067.886-.372-.765.58-1.728.859zM9.173 13.171a.14.14 0 10-.259.107.14.14 0 00.259-.107zM15.09 11.172l-1.828.614-.952.131.89-.363 1.89-.382zM15.034 11.6a.14.14 0 10.278-.036.14.14 0 00-.278.037zM8.91 12.828l1.828-.614.952-.13-.89.362-1.89.382zM8.966 12.4a.14.14 0 10-.278.036.14.14 0 00.278-.037zM15.2 12l-1.926.12-.953-.12.953-.12L15.2 12zM15.034 12.4a.14.14 0 10.277.036.14.14 0 00-.277-.037zM8.8 12l1.926-.12.953.12-.953.12L8.8 12zM8.966 11.6a.14.14 0 10-.277-.036.14.14 0 00.277.037zM15.091 12.828l-1.891-.382-.89-.363.952.131 1.829.614zM14.827 13.171a.14.14 0 10.26.107.14.14 0 00-.26-.107zM8.909 11.172l1.891.382.89.363-.952-.13-1.829-.615zM9.173 10.829a.14.14 0 10-.259-.107.14.14 0 00.259.107zM14.771 13.6l-1.727-.859-.766-.58.886.372L14.77 13.6zM14.428 13.863a.14.14 0 10.222.17.14.14 0 00-.222-.17zM9.229 10.4l1.727.859.766.58-.886-.372L9.23 10.4zM9.572 10.137a.14.14 0 10-.222-.17.14.14 0 00.222.17zM14.263 14.263l-1.447-1.277-.589-.759.759.59 1.277 1.446zM13.863 14.428a.14.14 0 10.17.222.14.14 0 00-.17-.222zM9.737 9.737l1.447 1.277.589.76-.759-.59-1.277-1.447zM10.137 9.572a.14.14 0 10-.17-.222.14.14 0 00.17.222zM13.6 14.771l-1.067-1.607-.373-.886.581.766.859 1.727zM13.171 14.827a.14.14 0 10.107.259.14.14 0 00-.107-.259zM10.4 9.229l1.067 1.607.373.886-.581-.766L10.4 9.23zM10.829 9.173a.14.14 0 10-.107-.259.14.14 0 00.107.259zM12.828 15.09l-.614-1.828-.131-.952.363.89.382 1.89zM12.4 15.034a.14.14 0 10.036.277.14.14 0 00-.037-.277zM11.172 8.909l.614 1.829.131.952-.363-.89-.382-1.891zM11.6 8.966a.14.14 0 10-.036-.278.14.14 0 00.037.278z",
    fill: "#07038D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "india_svg__clip0_6545_10389"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "india_svg__clip1_6545_10389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.ecc7233d4221b8c8d42a1ecef24280ba.svg";
export { ForwardRef as ReactComponent };